import React from "react"
import badge from "badges/planning-and-ordering.svg"
import { BadgeImage } from "backpack/badges/styled"

const PlanningAndOrdering = props => <BadgeImage src={badge} {...props} />

export default PlanningAndOrdering
